import { useCallback } from 'react';
import { z } from 'zod/mini';
import { OrderLineSchema } from '~/validation/api/packageSessionResponse';

export default function useOptionMapper(
  lines: z.infer<typeof OrderLineSchema>[],
) {
  // Retrieve the order lines for a specific order block
  const optionsForOrderBlock = useCallback((orderBlockId: number) => {
    return lines.filter((option) => option.order_block_id === orderBlockId);
  }, [lines]);

  const optionGroupsForOrderBlock = useCallback((orderBlockId: number) => {
    const orderLineGroups: Record<string, z.infer<typeof OrderLineSchema>[]> = {};

    // Retrieve all order lines for the order block
    const orderLineOptions = optionsForOrderBlock(orderBlockId);

    // Loop over the order lines, and place into a group based on the group_title
    orderLineOptions.forEach((orderLine) => {
      if (!orderLineGroups[orderLine.group_title]) {
        orderLineGroups[orderLine.group_title] = [];
      }

      orderLineGroups[orderLine.group_title].push(orderLine);
    });

    return orderLineGroups;
  }, [optionsForOrderBlock]);

  return {
    optionsForOrderBlock,
    optionGroupsForOrderBlock,
  };
}
